import {
    type IShipmentModeGroup,
    ShipmentModeGroup,
} from '@/app/modules/seating/guestOperations/Picker/domain/enums/shipmentModeGroup';

interface Seat {
    shipment_mode_type: string;
    shipment_mode_group: IShipmentModeGroup;
    barcode_is_available_for_distribution: boolean;
}

export const hasSeatPhysicalDistribution = (seat: Pick<Seat, 'shipment_mode_group'>) =>
    seat.shipment_mode_group === ShipmentModeGroup.PHYSICAL;

export const hasSeatETicketDistribution = (seat: Pick<Seat, 'shipment_mode_group'>) =>
    seat.shipment_mode_group === ShipmentModeGroup.E_TICKET;

export const hasSeatTournamentAppDistribution = (seat: Pick<Seat, 'shipment_mode_group'>) =>
    seat.shipment_mode_group === ShipmentModeGroup.TOURNAMENT_APP;

export const hasSeatBarcodeAvailable = (
    seat: Pick<Seat, 'barcode_is_available_for_distribution'>
) => seat.barcode_is_available_for_distribution;
